import { render } from "./traceability_report.vue?vue&type=template&id=08afcf38&scoped=true"
import script from "./traceability_report.js?vue&type=script&lang=js"
export * from "./traceability_report.js?vue&type=script&lang=js"

import "./traceability_report.vue?vue&type=style&index=0&id=08afcf38&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08afcf38"]])

export default __exports__